
export const binData = [
    {
      id: "2",
      bin: "521345",
      binName: "Mastercard Travel Gold",
      brand: "Mastercard",
      cardType: "Travel",
      cardLevel: "Gold",
      fundingType: "Credit",
      currency: "AED",
      countryUsage: "United Arab Emirates",
      status: "Active",
      createdAt: "2025-12-10",
      cardNature: "Physical",
      singleCardUsage: false,
      cardAdvance: true,
      cashAdvanceLimit: { type: "ABSOLUTE", value: 100000 },
      finalCashAdvanceLimit: 100000,
      cashAdvanceDailyCap: 20000,
      cashAdvanceFee: 50,
      maxCardLimit: 5000000,
      dailyLimit: 500000,
      monthlyLimit: 2500000,
      transactionLimit: 500000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Web","Recurring Payments"],
      recurringPaymentsUpto: "2027",  
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      emiDuration:["3","9"],
      txnPerDay: 8,
      txnPerHour: 4
    },
    {
      id: "3",
      bin: "412589",
      binName: "Visa Fuel Standard",
      brand: "Visa",
      cardType: "Fuel",
      cardLevel: "Standard",
      fundingType: "Prepaid",
      currency: "AED",
      countryUsage: "United Arab Emirates",
      status: "Active",
      createdAt: "2025-11-28",
      cardNature: "Hybrid",
      singleCardUsage: false,
      maxCardLimit: 2000000,
      dailyLimit: 200000,
      monthlyLimit: 1000000,
      transactionLimit: 100000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Web","App"],
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      emiDuration: ["3","6"],
      txnPerDay: 5,
      txnPerHour: 2
    },
    {
      id: "4",
      bin: "556712",
      binName: "Jaywan Procurement Gold",
      brand: "Jaywan",
      cardType: "Procurement",
      cardLevel: "Gold",
      fundingType: "Prepaid",
      currency: "AED",
      countryUsage: "United Arab Emirates",
      status: "Inactive",
      createdAt: "2025-11-15",
      cardNature: "Virtual",
      singleCardUsage: false,
      maxCardLimit: 7500000,
      dailyLimit: 1000000,
      monthlyLimit: 4000000,
      transactionLimit: 500000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["App","Recurring Payments"],
      recurringPaymentsUpto: "2028",
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 7,
      txnPerHour: 3,
      emiDuration: ["3","12"],
    },
    {
      id: "5",
      bin: "498712",
      binName: "Visa Project Premium",
      brand: "Visa",
      cardType: "Project",
      cardLevel: "Premium",
      fundingType: "Debit",
      currency: "USD",
      countryUsage: "United States",
      status: "Inactive",
      createdAt: "2025-10-22",
      cardNature: "Physical",
      singleCardUsage: false,
      maxCardLimit: 12000000,
      dailyLimit: 1500000,
      monthlyLimit: 6000000,
      transactionLimit: 1000000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Web","Recurring Payments"],
      recurringPaymentsUpto: "2027",
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 12,
      txnPerHour: 6,
      emiDuration: ["3","9","12"],
    },
    {
      id: "6",
      bin: "402345",
      binName: "Visa Corporate Gold",
      brand: "Visa",
      cardType: "Corporate",
      cardLevel: "Gold",
      fundingType: "Debit",
      currency: "USD",
      countryUsage: "United States",
      status: "Active",
      createdAt: "2025-12-01",
      cardNature: "Hybrid",
      singleCardUsage: true,
      maxCardLimit: 8000000,
      dailyLimit: 1000000,
      monthlyLimit: 5000000,
      transactionLimit: 700000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Web","App"],
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 10,
      txnPerHour: 5,
      emiDuration: ["6","9","12"],
    },
    {
      id: "7",
      bin: "530198",
      binName: "Jaywan Travel Platinum",
      brand: "Jaywan",
      cardType: "Travel",
      cardLevel: "Platinum",
      fundingType: "Prepaid",
      currency: "EUR",
      countryUsage: "Germany",
      status: "Active",
      createdAt: "2025-11-20",
      cardNature: "Physical",
      singleCardUsage: false,
      maxCardLimit: 10000000,
      dailyLimit: 2000000,
      monthlyLimit: 8000000,
      transactionLimit: 1500000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Recurring Payments"],
      recurringPaymentsUpto: "2027",
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 15,
      txnPerHour: 8,
      emiDuration: ["3","6","9"],
    },
    {
      id: "8",
      bin: "411234",
      binName: "Visa Fuel Standard Virtual",
      brand: "Visa",
      cardType: "Fuel",
      cardLevel: "Standard",
      fundingType: "Debit",
      currency: "AED",
      countryUsage: "United Arab Emirates",
      status: "Active",
      createdAt: "2025-10-30",
      cardNature: "Virtual",
      singleCardUsage: true,
      totalSpendLimit: 1000000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["App"],
      emiDuration: ["3","6","9","12"],
    },
    {
      id: "1",
      bin: "457623",
      binName: "Jaywan Corporate Premium",
      brand: "Jaywan",
      cardType: "Corporate",
      cardLevel: "Premium",
      fundingType: "Prepaid",
      currency: "AED",
      countryUsage: "United Arab Emirates",
      status: "Inactive",
      createdAt: "2025-12-15",
      cardNature: "Virtual",
      singleCardUsage: false,
      maxCardLimit: 10000000,
      dailyLimit: 1000000,
      monthlyLimit: 5000000,
      transactionLimit: 500000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Web"],
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 10,
      txnPerHour: 5,
      emiDuration: ["6","12"],
    },
    {
      id: "9",
      bin: "524678",
      binName: "Mastercard Project Premium",
      brand: "Mastercard",
      cardType: "Project",
      cardLevel: "Premium",
      fundingType: "Debit",
      currency: "GBP",
      countryUsage: "United Kingdom",
      status: "Inactive",
      createdAt: "2025-09-15",
      cardNature: "Physical",
      singleCardUsage: false,
      maxCardLimit: 12000000,
      dailyLimit: 1500000,
      monthlyLimit: 6000000,
      transactionLimit: 1000000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["App"],
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 12,
      txnPerHour: 6,
      emiDuration: ["3","12"],
    },
    {
      id: "10",
      bin: "453212",
      binName: "Jaywan Procurement Gold USD",
      brand: "Jaywan",
      cardType: "Procurement",
      cardLevel: "Gold",
      fundingType: "Debit",
      currency: "USD",
      countryUsage: "United States",
      status: "Inactive",
      createdAt: "2025-08-10",
      cardNature: "Hybrid",
      singleCardUsage: false,
      maxCardLimit: 7500000,
      dailyLimit: 1000000,
      monthlyLimit: 4000000,
      transactionLimit: 500000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Web","Recurring Payments"],
      recurringPaymentsUpto: "2027",
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 7,
      txnPerHour: 3,
      emiDuration: ["3","6","9"],
    },
    {
      id: "11",
      bin: "540012",
      binName: "Mastercard Corporate Platinum EUR",
      brand: "Mastercard",
      cardType: "Corporate",
      cardLevel: "Platinum",
      fundingType: "Credit",
      cardAdvance: true,
      cashAdvanceLimit: { type: "ABSOLUTE", value: 250000 },
      finalCashAdvanceLimit: 250000,
      cashAdvanceDailyCap: 25000,
      cashAdvanceFee: 70,
      currency: "EUR",
      countryUsage: "Germany",
      status: "Active",
      createdAt: "2025-07-22",
      cardNature: "Physical",
      singleCardUsage: false,
      maxCardLimit: 15000000,
      dailyLimit: 2000000,
      monthlyLimit: 8000000,
      transactionLimit: 1500000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["Web","App"],
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 15,
      txnPerHour: 8,
      emiDuration: ["6","9","12"],
    },
    {
      id: "12",
      bin: "421789",
      binName: "Visa Travel Standard AED",
      brand: "Visa",
      cardType: "Travel",
      cardLevel: "Standard",
      fundingType: "Credit",
      cardAdvance: true,
      cashAdvanceLimit: { type: "ABSOLUTE", value: 100000 },
      finalCashAdvanceLimit: 200000,
      cashAdvanceDailyCap: 50000,
      cashAdvanceFee: 50,
      currency: "AED",
      countryUsage: "United Arab Emirates",
      status: "Active",
      createdAt: "2025-06-15",
      cardNature: "Hybrid",
      singleCardUsage: false,
      maxCardLimit: 5000000,
      dailyLimit: 300000,
      monthlyLimit: 2000000,
      transactionLimit: 150000,
      expiryDate: 2027,
      allowCNP: true,
      cnpChannels: ["App","Recurring Payments"],  
      recurringPaymentsUpto: "2027",
      atmDailyLimit: 100000,
      atmMonthlyLimit: 500000,
      posDailyLimit: 100000,
      posMonthlyLimit: 500000,
      onlineDailyLimit: 100000,
      onlineMonthlyLimit: 500000,
      contactlessDailyLimit: 100000,
      contactlessMonthlyLimit: 500000,
      atmTransactionLimit: 50000,
      posTransactionLimit: 50000,
      onlineTransactionLimit: 50000,
      contactlessTransactionLimit: 50000,
      txnPerDay: 5,
      txnPerHour: 2,
      emiDuration: ["3","6","12"],
    },
  ];
  
  
  export const binWithMccs = [
    {
      bin: "521345",
      binName: "Mastercard Travel Gold",
      cardType: "Travel",
      mccs: [
        { code: "5411", name: "Grocery Stores" },
        { code: "5812", name: "Restaurants" },
        { code: "7011", name: "Hotels & Lodging" },
        { code: "4511", name: "Airlines" },
        { code: "4111", name: "Local Transport" }
      ]
    },
    {
      bin: "412589",
      binName: "Visa Fuel Standard",
      cardType: "Fuel",
      mccs: [
        { code: "5541", name: "Service Stations" },
        { code: "4789", name: "Tolls & Bridges" }
      ]
    },
    {
      bin: "556712",
      binName: "Jaywan Procurement Gold",
      cardType: "Procurement",
      mccs: [
        { code: "5812", name: "Restaurants" }
      ]
    },
    {
      bin: "498712",
      binName: "Visa Project Premium",
      cardType: "Project",
      mccs: [
        { code: "5999", name: "Misc Retail" }
      ]
    },
    {
      bin: "402345",
      binName: "Visa Corporate Gold",
      cardType: "Corporate",
      mccs: [
        { code: "4899", name: "Utilities" }
      ]
    },
    {
      bin: "530198",
      binName: "Jaywan Travel Platinum",
      cardType: "Travel",
      mccs: [
        { code: "4111", name: "Local Transport" }
      ]
    },
    {
      bin: "411234",
      binName: "Visa Fuel Standard Virtual",
      cardType: "Fuel",
      mccs: [
        { code: "5541", name: "Service Stations" }
      ]
    },
    {
      bin: "457623",
      binName: "Jaywan Corporate Premium",
      cardType: "Corporate",
      mccs: [
        { code: "5411", name: "Grocery Stores" },
        { code: "5812", name: "Restaurants" },
        { code: "4511", name: "Airlines" },
        { code: "5999", name: "Misc Retail" }
      ]
    },
    {
      bin: "453212",
      binName: "Jaywan Procurement Gold USD",
      cardType: "Procurement",
      mccs: [
        { code: "5411", name: "Grocery Stores" }
      ]
    },
    {
      bin: "540012",
      binName: "Mastercard Corporate Platinum EUR",
      cardType: "Corporate",
      mccs: [
        { code: "7832", name: "Cinemas" }
      ]
    },
    {
      bin: "421789",
      binName: "Visa Travel Standard AED",
      cardType: "Travel",
      mccs: [
        { code: "7011", name: "Hotels & Lodging" }
      ]
    },
    {
      bin: "524678",
      binName: "Mastercard Project Premium",
      cardType: "Project",
      mccs: []
    }
  ];
  

  export const clientsData = [
    {
        id:10004496,
        name: "Emirates NBD",
        mappedBINs: ["521345", "411234", "421789", "498712"]
    },
    {
      id: 10004480,
      name: "NBD Test",
      mappedBINs: ["457623", "521345", "498712"]
    },
    {
      id: 10004484,
      name: "Dubai Holding Test",
      mappedBINs: ["457623", "521345", "412589", "556712", "498712"]
    },
    {
      id: 10004485,
      name: "Test Emaar Properties",
      mappedBINs: ["457623", "556712", "453212"]
    },
    {
      id: 10004486,
      name: "Test Amazon MENA",
      mappedBINs: ["402345", "524678", "540012"]
    },
  ];
  
  
  
  export const mccData = [
    {
      id: "1",
      code: "5411",
      name: "Grocery Stores",
      category: "Retail",
      status: "Allowed",
      bins: ["457623", "521345", "453212"],
    },
    {
      id: "2",
      code: "5541",
      name: "Service Stations",
      category: "Fuel",
      status: "Allowed",
      bins: ["412589", "411234"],
    },
    {
      id: "3",
      code: "5812",
      name: "Restaurants",
      category: "Dining",
      status: "Allowed",
      bins: ["457623", "521345", "556712"],
    },
    {
      id: "4",
      code: "7011",
      name: "Hotels & Lodging",
      category: "Travel",
      status: "Allowed",
      bins: ["521345", "421789"],
    },
    {
      id: "5",
      code: "4511",
      name: "Airlines",
      category: "Travel",
      status: "Allowed",
      bins: ["521345", "457623"],
    },
    {
      id: "6",
      code: "4111",
      name: "Local Transport",
      category: "Transport",
      status: "Allowed",
      bins: ["521345", "530198"],
    },
    {
      id: "7",
      code: "4789",
      name: "Tolls & Bridges",
      category: "Transport",
      status: "Allowed",
      bins: ["412589"],
    },
    {
      id: "8",
      code: "5999",
      name: "Misc Retail",
      category: "Retail",
      status: "Allowed",
      bins: ["457623", "498712"],
    },
    {
      id: "9",
      code: "4899",
      name: "Utilities",
      category: "Utilities",
      status: "Allowed",
      bins: ["402345"],
    },
    {
      id: "10",
      code: "7995",
      name: "Gambling",
      category: "Entertainment",
      status: "Blocked",
      bins: [],
    },
    {
      id: "11",
      code: "7832",
      name: "Cinemas",
      category: "Entertainment",
      status: "Allowed",
      bins: ["540012"],
    },
    {
      id: "12",
      code: "5813",
      name: "Bars & Nightclubs",
      category: "Entertainment",
      status: "Blocked",
      bins: [],
    },
  ];

export const categories = [
    "Retail",
    "Fuel",
    "Dining",
    "Travel",
    "Entertainment",
    "Grocery",
    "Hotel & Lodging",
    "Utilities",
    "Healthcare",
    "Education",
    "Transportation",
    "Procurement",
    "Telecommunications"
  ];
  

  export  const sampleCountries = [
    { id: "1", countryCode: "AE", countryName: "United Arab Emirates", region: "GCC", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "2", countryCode: "SA", countryName: "Saudi Arabia", region: "GCC", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "3", countryCode: "KW", countryName: "Kuwait", region: "GCC", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "4", countryCode: "QA", countryName: "Qatar", region: "GCC", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "5", countryCode: "BH", countryName: "Bahrain", region: "GCC", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "6", countryCode: "OM", countryName: "Oman", region: "GCC", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "7", countryCode: "US", countryName: "United States", region: "International", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "8", countryCode: "GB", countryName: "United Kingdom", region: "International", status: "allowed", riskLevel: "low", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
    { id: "9", countryCode: "RU", countryName: "Russia", region: "International", status: "blocked", riskLevel: "high", associatedBINs: [], sanctioned: true },
    { id: "10", countryCode: "KP", countryName: "North Korea", region: "International", status: "blocked", riskLevel: "high", associatedBINs: [], sanctioned: true },
    { id: "11", countryCode: "IR", countryName: "Iran", region: "International", status: "blocked", riskLevel: "high", associatedBINs: [], sanctioned: true },
    { id: "12", countryCode: "NG", countryName: "Nigeria", region: "International", status: "restricted", riskLevel: "medium", associatedBINs: ["457623", "521345", "453212"], sanctioned: false },
  ];
    

  export const countryReferenceList = [
    { countryCode: "AE", countryName: "United Arab Emirates", currency: "AED" },
    { countryCode: "SA", countryName: "Saudi Arabia", currency: "SAR" },
    { countryCode: "KW", countryName: "Kuwait", currency: "KWD" },
    { countryCode: "QA", countryName: "Qatar", currency: "QAR" },
    { countryCode: "BH", countryName: "Bahrain", currency: "BHD" },
    { countryCode: "OM", countryName: "Oman", currency: "OMR" },
  
    { countryCode: "US", countryName: "United States", currency: "USD" },
    { countryCode: "GB", countryName: "United Kingdom", currency: "GBP" },
    { countryCode: "CA", countryName: "Canada", currency: "CAD" },
    { countryCode: "AU", countryName: "Australia", currency: "AUD" },
    { countryCode: "DE", countryName: "Germany", currency: "EUR" },
    { countryCode: "FR", countryName: "France", currency: "EUR" },
    { countryCode: "IT", countryName: "Italy", currency: "EUR" },
    { countryCode: "ES", countryName: "Spain", currency: "EUR" },
    { countryCode: "NL", countryName: "Netherlands", currency: "EUR" },
  
    { countryCode: "IN", countryName: "India", currency: "INR" },
    { countryCode: "SG", countryName: "Singapore", currency: "SGD" },
    { countryCode: "HK", countryName: "Hong Kong", currency: "HKD" },
    { countryCode: "JP", countryName: "Japan", currency: "JPY" },
    { countryCode: "KR", countryName: "South Korea", currency: "KRW" },
    { countryCode: "CN", countryName: "China", currency: "CNY" },
  
    { countryCode: "NG", countryName: "Nigeria", currency: "NGN" },
    { countryCode: "ZA", countryName: "South Africa", currency: "ZAR" },
    { countryCode: "KE", countryName: "Kenya", currency: "KES" },
  
    { countryCode: "RU", countryName: "Russia", currency: "RUB" },
    { countryCode: "IR", countryName: "Iran", currency: "IRR" },
    { countryCode: "KP", countryName: "North Korea", currency: "KPW" },
  ];
  

  export const kpiData = [
    { label: 'Total Corporates', value: '2,845', trend: 12, bgColor: '#eff6ff' },
    { label: 'Active Corporates', value: '2,456', trend: 8, bgColor: '#ecfdf5' },
    { label: 'Total Users', value: '15,234', trend: 15, bgColor: '#f5f3ff' },
    { label: 'Active Users', value: '12,890', trend: 10, bgColor: '#fdf2f8' },
    { label: 'Total Cards Issued', value: '45,678', trend: 20, bgColor: '#fefce8' },
    { label: 'Active Cards', value: '38,234', trend: 18, bgColor: '#fff7ed' },
    { label: 'Total Spend (AED)', value: 'AED 2.4B', trend: 25, bgColor: '#f0fdfa' },
    { label: 'Total Transactions', value: '1.2M', trend: 22, bgColor: '#eef2ff' },
  ];
  
  export const trendData = [
    { month: 'Jan', amount: 180000, count: 95000 },
    { month: 'Feb', amount: 195000, count: 98000 },
    { month: 'Mar', amount: 210000, count: 102000 },
    { month: 'Apr', amount: 205000, count: 100000 },
    { month: 'May', amount: 220000, count: 105000 },
    { month: 'Jun', amount: 235000, count: 110000 },
    { month: 'Jul', amount: 240000, count: 112000 },
    { month: 'Aug', amount: 250000, count: 115000 },
  ];
  
  export const platformUsageData = [
    { name: 'Cards', value: 45 },
    { name: 'Expense', value: 25 },
    { name: 'AP', value: 20 },
    { name: 'Payments', value: 10 },
  ];
  
  export const transactionStatusData = [
    { status: 'Completed', cards: 35000, expense: 22000, ap: 18000, payments: 8000 },
    { status: 'Pending', cards: 3234, expense: 3000, ap: 2000, payments: 2000 },
  ];

  export const kpiCardsData = [
    { label: 'Cards Issued', value: '45,678', trend: 12, bgColor: 'bg-blue-50' },
    { label: 'Active Cards', value: '38,234', trend: 10, bgColor: 'bg-green-50' },
    { label: 'Monthly Spend', value: 'AED 342M', trend: 18, bgColor: 'bg-purple-50' },
    { label: 'Decline Rate', value: '2.3%', trend: -5, bgColor: 'bg-red-50' },
    { label: 'Avg Spend per Card', value: 'AED 8,945', trend: 8, bgColor: 'bg-yellow-50' },
  ];
  
  export const cardTypeData = [
    { name: 'Corporate', value: 45 },
    { name: 'Business', value: 30 },
    { name: 'Commercial', value: 25 },
  ];
  
  export const fundingTypeData = [
    { name: 'Prepaid', value: 40 },
    { name: 'Credit', value: 35 },
    { name: 'Charge', value: 25 },
  ];
  
  export const spendRiskData = [
    { month: 'Jan', approved: 45000, declined: 1200 },
    { month: 'Feb', approved: 48000, declined: 1100 },
    { month: 'Mar', approved: 52000, declined: 1300 },
    { month: 'Apr', approved: 50000, declined: 1000 },
    { month: 'May', approved: 55000, declined: 1200 },
    { month: 'Jun', approved: 58000, declined: 1400 },
  ];
  
  export const declineReasons = [
    { reason: 'Insufficient Funds', count: 450 },
    { reason: 'Expired Card', count: 320 },
    { reason: 'Invalid CVV', count: 280 },
    { reason: 'Blocked MCC', count: 210 },
    { reason: 'Other', count: 150 },
  ];

  export const binLevelData = [
    { bin: '435678', brand: 'Jaywan', cardType: 'Corporate', activeCorporates: 234, cardsIssued: 5678, spend: 'AED 45.2M', declineRate: '1.8%' },
    { bin: '512345', brand: 'Mastercard', cardType: 'Business', activeCorporates: 189, cardsIssued: 4321, spend: 'AED 38.7M', declineRate: '2.1%' },
    { bin: '435690', brand: 'Jaywan', cardType: 'Commercial', activeCorporates: 156, cardsIssued: 3456, spend: 'AED 32.4M', declineRate: '1.5%' },
    { bin: '512367', brand: 'Mastercard', cardType: 'Corporate', activeCorporates: 201, cardsIssued: 4987, spend: 'AED 41.2M', declineRate: '2.3%' },
    { bin: '435612', brand: 'VISA', cardType: 'Business', activeCorporates: 143, cardsIssued: 2987, spend: 'AED 28.9M', declineRate: '1.9%' },
  ];


  export const kpiExpenseData = [
    { label: 'Total Expenses', value: 'AED 22,854', trend: 15, bgColor: 'bg-blue-50' },
    { label: 'Total Amount', value: 'AED 125.4M', trend: 20, bgColor: 'bg-purple-50' },
    { label: 'Paid', value: 'AED 18,234', trend: 12, bgColor: 'bg-green-50' },
    { label: 'Unpaid', value: 'AED 4,620', trend: -8, bgColor: 'bg-orange-50' },
    { label: 'Self-Paid', value: 'AED 11,202', trend: 18, bgColor: 'bg-teal-50' },
    { label: 'Company-Paid', value: 'AED 11,652', trend: 22, bgColor: 'bg-indigo-50' },
  ];
  
  export const expenseTypeSplit = {
    selfPaid: {
      totalExpenses: 11202,
      totalAmount: 'AED 62.3M',
      avgAmount: 'AED 5,560',
      paidCount: 10830,
      paidAmount: 'AED 60.1M',
    },
    pettyCash: {
      totalExpenses: 3643,
      totalAmount: 'AED 8.2M',
      avgAmount: 'AED 2,250',
      paidCount: 3421,
      paidAmount: 'AED 7.8M',
    },
  };
  
  export const monthlyTrendData = [
    { month: 'Jun 25', amount: 10500000, count: 3744 },
    { month: 'Jul 25', amount: 11200000, count: 3699 },
    { month: 'Aug 25', amount: 10800000, count: 3786 },
    { month: 'Sep 25', amount: 11500000, count: 3547 },
    { month: 'Oct 25', amount: 12000000, count: 3708 },
    { month: 'Nov 25', amount: 11800000, count: 3820 },
    { month: 'Dec 25', amount: 12500000, count: 3900 },
    { month: 'Jan 26', amount: 13200000, count: 4050 },
  ];
  
  export const monthlyExpenseTableData = [
    { month: 'Jun 25', totalUsers: 2744, activeUsers: 1246, expenseCount: 20154, expenseAmount: 'AED 12,836,071', paidCount: 13265, paidAmount: 'AED 11,540,594', selfPaidCount: 10930, selfPaidAmount: 'AED 12,143,227' },
    { month: 'Jul 25', totalUsers: 3699, activeUsers: 1277, expenseCount: 22219, expenseAmount: 'AED 13,315,601', paidCount: 10728, paidAmount: 'AED 12,285,522', selfPaidCount: 10683, selfPaidAmount: 'AED 13,279,614' },
    { month: 'Aug 25', totalUsers: 3786, activeUsers: 1256, expenseCount: 22969, expenseAmount: 'AED 13,212,642', paidCount: 18899, paidAmount: 'AED 12,354,109', selfPaidCount: 11539, selfPaidAmount: 'AED 14,275,342' },
    { month: 'Sep 25', totalUsers: 3547, activeUsers: 1219, expenseCount: 22852, expenseAmount: 'AED 12,482,843', paidCount: 20923, paidAmount: 'AED 12,816,320', selfPaidCount: 11204, selfPaidAmount: 'AED 13,088,203' },
    { month: 'Oct 25', totalUsers: 3708, activeUsers: 1245, expenseCount: 23819, expenseAmount: 'AED 14,451,218', paidCount: 22002, paidAmount: 'AED 13,293,263', selfPaidCount: 11792, selfPaidAmount: 'AED 13,986,701' },
  ];

  export const kpiApData = [
    { label: 'Total Vendors', value: 'AED1,245', trend: 8, bgColor: 'bg-blue-50' },
    { label: 'Total AP Amount', value: 'AED 89.2M', trend: 15, bgColor: 'bg-purple-50' },
    { label: 'Paid AP', value: 'AED 67.5M', trend: 12, bgColor: 'bg-green-50' },
    { label: 'Pending AP', value: 'AED 21.7M', trend: -5, bgColor: 'bg-orange-50' },
  ];
  
  export const settlementTrendData = [
    { month: 'Jun', avgDays: 12, paid: 8500000, pending: 2200000 },
    { month: 'Jul', avgDays: 11, paid: 9200000, pending: 2100000 },
    { month: 'Aug', avgDays: 10, paid: 9800000, pending: 1900000 },
    { month: 'Sep', avgDays: 11, paid: 10100000, pending: 2000000 },
    { month: 'Oct', avgDays: 9, paid: 10500000, pending: 1800000 },
    { month: 'Nov', avgDays: 10, paid: 11200000, pending: 1700000 },
    { month: 'Dec', avgDays: 9, paid: 11800000, pending: 1600000 },
  ];
  
  export const apAgingData = [
    { bucket: '0-30 days', amount: 15200000, count: 845 },
    { bucket: '31-60 days', amount: 4800000, count: 267 },
    { bucket: '61-90 days', amount: 1200000, count: 89 },
    { bucket: '90+ days', amount: 500000, count: 44 },
  ];
  

  export const kpiInvoiceData = [
    { label: 'Invoices Generated', value: '8,456', trend: 14, bgColor: 'bg-blue-50' },
    { label: 'Invoices Paid', value: '6,892', trend: 12, bgColor: 'bg-green-50' },
    { label: 'Outstanding', value: '1,234', trend: -8, bgColor: 'bg-orange-50' },
    { label: 'Overdue', value: '330', trend: -15, bgColor: 'bg-red-50' },
  ];
  
  export const invoiceTrendData = [
    { month: 'Jun', generated: 980000, paid: 850000, unpaid: 130000 },
    { month: 'Jul', generated: 1050000, paid: 920000, unpaid: 130000 },
    { month: 'Aug', generated: 1120000, paid: 980000, unpaid: 140000 },
    { month: 'Sep', generated: 1080000, paid: 950000, unpaid: 130000 },
    { month: 'Oct', generated: 1200000, paid: 1050000, unpaid: 150000 },
    { month: 'Nov', generated: 1280000, paid: 1120000, unpaid: 160000 },
    { month: 'Dec', generated: 1350000, paid: 1180000, unpaid: 170000 },
  ];
  
  export const statusData = [
    { status: 'Paid', count: 6892 },
    { status: 'Pending', count: 1234 },
    { status: 'Overdue', count: 330 },
  ];
  
  export const agingData = [
    { invoiceId: 'INV-2024-0156', corporate: 'Tech Solutions Ltd', amount: 'AED 125,000', ageBucket: '0-30 days', status: 'Pending', dueDate: '2024-01-15' },
    { invoiceId: 'INV-2024-0142', corporate: 'Global Industries', amount: 'AED 89,500', ageBucket: '31-60 days', status: 'Pending', dueDate: '2023-12-28' },
    { invoiceId: 'INV-2024-0128', corporate: 'Retail Enterprises', amount: 'AED 245,000', ageBucket: '0-30 days', status: 'Pending', dueDate: '2024-01-20' },
    { invoiceId: 'INV-2024-0089', corporate: 'Manufacturing Corp', amount: 'AED 67,800', ageBucket: '61-90 days', status: 'Overdue', dueDate: '2023-11-30' },
    { invoiceId: 'INV-2024-0067', corporate: 'Services Group', amount: 'AED 156,000', ageBucket: '31-60 days', status: 'Pending', dueDate: '2023-12-15' },
    { invoiceId: 'INV-2023-0987', corporate: 'Delta Trading LLC', amount: 'AED 198,500', ageBucket: '90+ days', status: 'Overdue', dueDate: '2023-10-20' },
    { invoiceId: 'INV-2024-0145', corporate: 'Alpha Corp', amount: 'AED 78,900', ageBucket: '0-30 days', status: 'Pending', dueDate: '2024-01-18' },
    { invoiceId: 'INV-2024-0112', corporate: 'Beta Industries', amount: 'AED 312,000', ageBucket: '31-60 days', status: 'Pending', dueDate: '2023-12-22' },
  ];
  

export const kpiPaymentData = [
    { label: 'Total Payments', value: '52,345', trend: 18, bgColor: 'bg-blue-50' },
    { label: 'Success Rate', value: '96.8%', trend: 2, bgColor: 'bg-green-50' },
    { label: 'Failed Rate', value: '3.2%', trend: -1, bgColor: 'bg-red-50' },
    { label: 'Retry Success', value: '78%', trend: 5, bgColor: 'bg-purple-50' },
  ];
  
  export const paymentFlowData = {
    requested: 52345,
    processed: 51234,
    settled: 50678,
    failed: 1667,
  };
  
  export const failureReasonsData = [
    { reason: 'Insufficient Balance', count: 645 },
    { reason: 'Bank System Error', count: 423 },
    { reason: 'Invalid Account', count: 287 },
    { reason: 'Network Timeout', count: 189 },
    { reason: 'Duplicate Request', count: 123 },
  ];
  
  export const failedPaymentsData = [
    { id: 'PAY-2024-001', corporate: 'Tech Corp LLC', amount: 'AED 45,000', reason: 'Insufficient Balance', date: '2024-01-05', status: 'Retry Pending' },
    { id: 'PAY-2024-002', corporate: 'Global Industries', amount: 'AED 78,500', reason: 'Bank System Error', date: '2024-01-05', status: 'Failed' },
    { id: 'PAY-2024-003', corporate: 'Retail Solutions', amount: 'AED 32,000', reason: 'Invalid Account', date: '2024-01-04', status: 'Retry Pending' },
    { id: 'PAY-2024-004', corporate: 'Manufacturing Co', amount: 'AED 125,000', reason: 'Network Timeout', date: '2024-01-04', status: 'Retrying' },
    { id: 'PAY-2024-005', corporate: 'Service Provider', amount: 'AED 56,700', reason: 'Duplicate Request', date: '2024-01-03', status: 'Failed' },
  ];

  export const kpiCorporateUserData = [
    { label: 'Total Corporates', value: '2,845', trend: 12, bgColor: 'bg-blue-50' },
    { label: 'Active Corporates', value: '2,456', trend: 8, bgColor: 'bg-green-50' },
    { label: 'Total Users', value: '15,234', trend: 15, bgColor: 'bg-purple-50' },
    { label: 'Active Users', value: '12,890', trend: 10, bgColor: 'bg-pink-50' },
    { label: 'Avg Users/Corporate', value: '5.4', trend: 5, bgColor: 'bg-yellow-50' },
  ];
  
  export const topCorporatesData = [
    { name: 'Tech Solutions Ltd', spend: 15600000, cards: 234, users: 187, exposure: 85 },
    { name: 'Global Industries Inc', spend: 14200000, cards: 198, users: 156, exposure: 78 },
    { name: 'Retail Enterprises', spend: 12800000, cards: 176, users: 143, exposure: 72 },
    { name: 'Manufacturing Corp', spend: 11500000, cards: 165, users: 132, exposure: 68 },
    { name: 'Services Group', spend: 10200000, cards: 145, users: 118, exposure: 64 },
  ];
  
  export const limitWarningData = [
    { corporate: 'Delta Trading LLC', limit: 'AED 20M', utilized: 'AED 19.2M', percentage: 96, risk: 'High' },
    { corporate: 'Alpha Corp', limit: 'AED 15M', utilized: 'AED 13.8M', percentage: 92, risk: 'High' },
    { corporate: 'Beta Industries', limit: 'AED 25M', utilized: 'AED 22.5M', percentage: 90, risk: 'Medium' },
    { corporate: 'Gamma Solutions', limit: 'AED 18M', utilized: 'AED 15.8M', percentage: 88, risk: 'Medium' },
  ];
  
  export const featureAdoptionData = [
    { feature: 'Cards Module', adoption: 89, corporates: 2532 },
    { feature: 'Expense Module', adoption: 76, corporates: 2162 },
    { feature: 'AP Module', adoption: 64, corporates: 1821 },
    { feature: 'Payments Module', adoption: 58, corporates: 1650 },
    { feature: 'Invoice Module', adoption: 45, corporates: 1280 },
  ];

  export const alertsData = [
    { id: 1, type: 'KYC Pending', corporate: 'New Tech Solutions', severity: 'high', count: 3, dueDate: '2024-01-10' },
    { id: 2, type: 'Limit Breach Attempt', corporate: 'Delta Trading LLC', severity: 'high', count: 2, dueDate: '2024-01-08' },
    { id: 3, type: 'High-Risk MCC Activity', corporate: 'Global Retail', severity: 'medium', count: 5, dueDate: '2024-01-12' },
    { id: 4, type: 'Unusual Spending Pattern', corporate: 'Service Provider Inc', severity: 'medium', count: 1, dueDate: '2024-01-15' },
    { id: 5, type: 'Multiple Failed Transactions', corporate: 'Manufacturing Co', severity: 'low', count: 4, dueDate: '2024-01-20' },
  ];
  
  export const declineTrendData = [
    { month: 'Jun', declines: 1200, fraudAttempts: 45 },
    { month: 'Jul', declines: 1100, fraudAttempts: 38 },
    { month: 'Aug', declines: 1300, fraudAttempts: 52 },
    { month: 'Sep', declines: 1000, fraudAttempts: 34 },
    { month: 'Oct', declines: 1200, fraudAttempts: 41 },
    { month: 'Nov', declines: 1400, fraudAttempts: 48 },
    { month: 'Dec', declines: 1100, fraudAttempts: 36 },
  ];
  
  export const mccRiskData = [
    { mcc: '5812', category: 'Restaurants', transactions: 8456, declines: 234, riskScore: 2.8 },
    { mcc: '5411', category: 'Grocery Stores', transactions: 6234, declines: 89, riskScore: 1.4 },
    { mcc: '4789', category: 'Transportation', transactions: 5678, declines: 198, riskScore: 3.5 },
    { mcc: '5921', category: 'Liquor Stores', transactions: 1234, declines: 156, riskScore: 12.6 },
    { mcc: '7995', category: 'Gambling', transactions: 456, declines: 98, riskScore: 21.5 },
  ];        
  
  export const auditLogData = [
    {
      id: 'AUD-001',
      actionType: 'BIN Limit Updated',
      entity: 'BIN 435678',
      oldValue: 'AED 50M',
      newValue: 'AED 75M',
      adminUser: 'admin@emiratesnbd.ae',
      timestamp: '2024-01-06 14:32:15',
    },
    {
      id: 'AUD-002',
      actionType: 'MCC Blocked',
      entity: 'MCC 7995 (Gambling)',
      oldValue: 'Active',
      newValue: 'Blocked',
      adminUser: 'admin@emiratesnbd.ae',
      timestamp: '2024-01-06 13:45:22',
    },
    {
      id: 'AUD-003',
      actionType: 'Corporate Limit Modified',
      entity: 'Tech Solutions Ltd',
      oldValue: 'AED 10M',
      newValue: 'AED 15M',
      adminUser: 'superadmin@emiratesnbd.ae',
      timestamp: '2024-01-06 12:18:45',
    },
    {
      id: 'AUD-004',
      actionType: 'User Access Revoked',
      entity: 'user@techsolutions.com',
      oldValue: 'Active',
      newValue: 'Suspended',
      adminUser: 'admin@emiratesnbd.ae',
      timestamp: '2024-01-06 11:23:10',
    },
    {
      id: 'AUD-005',
      actionType: 'Card Type Enabled',
      entity: 'BIN 512345',
      oldValue: 'Corporate Only',
      newValue: 'Corporate + Business',
      adminUser: 'admin@emiratesnbd.ae',
      timestamp: '2024-01-06 10:15:33',
    },
    {
      id: 'AUD-006',
      actionType: 'Decline Rule Modified',
      entity: 'Rule DR-456',
      oldValue: '3 attempts',
      newValue: '5 attempts',
      adminUser: 'superadmin@emiratesnbd.ae',
      timestamp: '2024-01-06 09:42:18',
    },
    {
      id: 'AUD-007',
      actionType: 'BIN Configuration',
      entity: 'BIN 435690',
      oldValue: 'Prepaid Only',
      newValue: 'Prepaid + Credit',
      adminUser: 'admin@emiratesnbd.ae',
      timestamp: '2024-01-05 16:55:44',
    },
    {
      id: 'AUD-008',
      actionType: 'Corporate Onboarded',
      entity: 'New Tech Ventures',
      oldValue: 'N/A',
      newValue: 'Active',
      adminUser: 'admin@emiratesnbd.ae',
      timestamp: '2024-01-05 15:30:22',
    },
    {
      id: 'AUD-009',
      actionType: 'MCC Limit Set',
      entity: 'MCC 5812 (Restaurants)',
      oldValue: 'Unlimited',
      newValue: 'AED 50,000 per transaction',
      adminUser: 'superadmin@emiratesnbd.ae',
      timestamp: '2024-01-05 14:12:05',
    },
    {
      id: 'AUD-010',
      actionType: 'Admin Role Changed',
      entity: 'manager@emiratesnbd.ae',
      oldValue: 'Viewer',
      newValue: 'Admin',
      adminUser: 'superadmin@emiratesnbd.ae',
      timestamp: '2024-01-05 13:45:30',
    },
  ];
  
  export const summaryStats = [
    { label: 'Total Actions Today', value: '47', color: 'bg-blue-50 text-blue-700' },
    { label: 'Critical Changes', value: '12', color: 'bg-red-50 text-red-700' },
    { label: 'Active Admins', value: '8', color: 'bg-green-50 text-green-700' },
    { label: 'Failed Actions', value: '2', color: 'bg-orange-50 text-orange-700' },
  ];

  export const mccDataExtra = [
    // ---- Original MCCs ----
    { code: "5411", name: "Grocery Stores" },
    { code: "5541", name: "Service Stations" },
    { code: "5812", name: "Restaurants" },
    { code: "7011", name: "Hotels & Lodging" },
    { code: "4511", name: "Airlines" },
    { code: "4111", name: "Local Transport" },
    { code: "4789", name: "Tolls & Bridges" },
    { code: "5999", name: "Misc Retail" },
    { code: "4899", name: "Utilities" },
  
    // ---- General MCCs ----
    { code: "4814", name: "Telecommunication Services" },
    { code: "5732", name: "Electronics Stores" },
    { code: "5944", name: "Jewelry Stores" },
    { code: "7399", name: "Business Services" },
    { code: "5977", name: "Cosmetic & Beauty Stores" },
    { code: "5122", name: "Pharmaceuticals" },
    { code: "5941", name: "Sporting Goods Stores" },
    { code: "7299", name: "Personal Services" },
  
    // ---- Travel MCCs ----
    { code: "3000", name: "United Airlines" },
    { code: "3351", name: "Car Rental Agencies" },
    { code: "4722", name: "Travel Agencies" },
    { code: "7012", name: "Timeshare & Vacation Properties" },
    { code: "7032", name: "Sporting & Recreation Camps" },
    { code: "7991", name: "Tourist Attractions" },
    { code: "4784", name: "Toll & Parking Facilities" },
  ];


  export const cardTypes = [
    "Corporate Spends",
    "Travel",
    "Fuel",
    "Procurement",
    "Project",
  ];
  
  export const paymentStatusData = [
    { status: 'Success', count: 8268 },
    { status: 'Failed', count: 186 },
    { status: 'Pending', count: 156 },
  ];
  
  export const failureReasons = [
    { reason: 'Insufficient Funds', count: 78 },
    { reason: 'Invalid Account', count: 45 },
    { reason: 'Network Error', count: 32 },
    { reason: 'Timeout', count: 21 },
    { reason: 'Other', count: 10 },
  ];

    
  export const cardPhysicalVsVirtual = [
    { name: 'Physical Cards', value: 534 },
    { name: 'Virtual Cards', value: 358 },
  ];
  

  